export enum AxisNameType {
  X = 'x',
  Y = 'y',
}

export enum StateAxisType {
  AXIS = 'axis',
  EMISSION_AXIS = 'emissionAxis',
}

export enum EmissionYAxisType {
  CH4_CO2 = 'ch4_co2',
  N2O = 'n20',
}
export enum AxisIntervalBorderNameType {
  MIN = 'min',
  MAX = 'max',
}

export type AxisIntervalType = Record<AxisIntervalBorderNameType, number | null>;
export type AxisFormikIntervalType = Record<AxisIntervalBorderNameType, string>;
export type AxisIntervalsType = {
  [AxisNameType.X]: AxisIntervalType;
  [AxisNameType.Y]: AxisIntervalType;
};
export type EmissionsYAxisIntervalsType = {
  [EmissionYAxisType.CH4_CO2]: AxisIntervalType;
  [EmissionYAxisType.N2O]: AxisIntervalType;
};

export type AxisIntervalValidationResultType = Partial<Record<AxisIntervalBorderNameType, undefined | string>>;
export type ValidationInputType = Record<AxisIntervalBorderNameType, string>;
export type ValidateIntervalValuesCallbackType = (values: ValidationInputType) => AxisIntervalValidationResultType;

export interface AxisIntervalActionPayloadType<T = AxisNameType> {
  axisName: T;
  borderName: AxisIntervalBorderNameType;
  value: null | number;
}
